import ConsultaExpress from './ConsultaExpress';

export default ConsultaExpress;
